import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Box } from "@vk-hr-tek/ui/Box";
import { SubmitError } from "../SubmitError/index.js";
import { SUBMIT_ERROR_TEXT } from "../form.constants.js";
const FormError = (t0)=>{
    const $ = c(5);
    const { error } = t0;
    const t1 = error && error.description ? error.description : SUBMIT_ERROR_TEXT;
    const t2 = error && error.traceId;
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            title: t1,
            traceId: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const t4 = t3;
    let t5;
    if ($[3] !== t4) {
        t5 = /*#__PURE__*/ jsx(Box, {
            pt: "20",
            children: /*#__PURE__*/ jsx(SubmitError, {
                submitError: t4
            })
        });
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
};
export { FormError };
